module.exports = __webpack_public_path__ + "static/media/icon_journal.809ef5f6.svg";